import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  FlexBox, FlexItem, Image, Link, Space
} from '@codex/basics';

const IMAGE_SPACE = 20;

export const ProductWrapper = styled(FlexBox)`
  padding: 10px;
  margin: 5px 0;
  border: 1px solid ${props => props.theme.colors.shades[5]};
  background-color: ${props => props.theme.colors.shades[7]};
`;

export const Hint = styled.div`
  font-size: 12px;
  color: ${props => props.theme.colors.shades[4]};
`;

const Product = props => (
  <ProductWrapper>
    <FlexItem basis={`${props.imageWidth}px`}>
      <Space right={IMAGE_SPACE}>
        <Image
          alt={props.title}
          image={props.imageUrl}
          link={props.link}
          width={props.imageWidth}
          height={props.imageHeight}
        />
      </Space>
    </FlexItem>

    <FlexItem basis={`calc(100% - ${props.imageWidth + IMAGE_SPACE}px)`}>
      {props.hint &&
        <Hint>{props.hint}</Hint>}

      <Link href={props.link}>
        {props.title}
      </Link>
    </FlexItem>
  </ProductWrapper>
);

Product.propTypes = {
  id: PropTypes.string,
  imageUrl: PropTypes.string,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  hint: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string
};

Product.defaultProps = {
  id: '',
  imageUrl: '',
  imageHeight: 70,
  imageWidth: 79,
  hint: '',
  link: '',
  title: ''
};

export default Product;
